import Vue from "vue";
import VueRouter from "vue-router";

// 引入nprogress #一款页面加载时进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Home",
  },
  {
    // 推荐页面
    path: "/Home",
    name: "Home",
    component: () => import("@/views/Home/index"),
    meta: { title: "首页" },
  },
  // {
  //   // 推介办法
  //   path: "/Recommendation",
  //   name: "Recommendation",
  //   component: () => import("@/views/Recommendation/index"),
  //   meta: { title: "推介办法" },
  // },
  {
    // 推荐单位
    path: "/Recommending",
    name: "Recommending",
    component: () => import("@/views/Recommending/index"),
    meta: { title: "推荐单位" },
  },
  {
    // 专家委员会
    path: "/ExpertCommittee",
    name: "ExpertCommittee",
    component: () => import("@/views/ExpertCommittee/index"),
    meta: { title: "专家委员会" },
  },
  {
    // 活动之窗
    path: "/WindowOfActivity",
    name: "WindowOfActivity",
    component: () => import("@/views/WindowOfActivity/index"),
    meta: { title: "活动之窗" },
  },
  {
    // 工程简介
    path: "/ProjectIntroduction",
    name: "ProjectIntroduction",
    component: () => import("@/views/ProjectIntroduction/index"),
    meta: { title: "工程简介" },
  },
  {
    // 工程简介
    path: "/News",
    name: "News",
    component: () => import("@/views/news/index"),
    meta: { title: "动态新闻" },
  },
  {
    // 工程简介
    path: "/NewsDetail",
    name: "NewsDetail",
    component: () => import("@/views/news/detail"),
    meta: { title: "动态新闻详情" },
  },
  {
    // 工程简介
    path: "/Shortlisted",
    name: "Shortlisted",
    component: () => import("@/views/shortlisted/index"),
    meta: { title: "入围成果" },
  },
  {
    // 工程简介
    path: "/Nominated",
    name: "Nominated",
    component: () => import("@/views/nominated/index"),
    meta: { title: "提名成果" },
  },
  {
    // 工程简介
    path: "/AchievementDetail",
    name: "AchievementDetail",
    component: () => import("@/views/ScientificResearch/components/achievementDetail"),
    meta: { title: "成果详情" },
  },
  {
    // 工程简介
    path: "/CoverDetail",
    name: "CoverDetail",
    component: () => import("@/views/ScientificResearch/components/coverDetail"),
    meta: { title: "方案详情" },
  },
  {
    // 工程简介
    path: "/ApplyForm",
    name: "ApplyForm",
    component: () => import("@/views/ScientificResearch/components/applyForm"),
    meta: { title: "成果申请" },
  },
  {
    // 工程简介
    path: "/Notice",
    name: "Notice",
    component: () => import("@/views/notice/index"),
    meta: { title: "通知公告" },
  },
  {
    // 工程简介
    path: "/NoticeDetail",
    name: "NoticeDetail",
    component: () => import("@/views/notice/detail"),
    meta: { title: "通知公告详情" },
  },
  {
    // 工程简介
    path: "/FileDownload",
    name: "FileDownload",
    component: () => import("@/views/fileDownload/index"),
    meta: { title: "文件下载" },
  },
  {
    // 工程简介
    path: "/FileDownloadDetail",
    name: "FileDownloadDetail",
    component: () => import("@/views/fileDownload/detail"),
    meta: { title: "文件下载详情" },
  },
  {
    // 第一届新动能科技成果
    path: "/ScientificResearch",
    name: "ScientificResearch",
    component: () => import("@/views/ScientificResearch/index"),
    meta: { title: "第一届新动能科技成果" },
  },
  {
    // 证书查询
    path: "/CertificateInquiry",
    name: "CertificateInquiry",
    component: () => import("@/views/CertificateInquiry/index"),
    meta: { title: "证书查询" ,hideTopbar: true},
  },
  {
    // 后台管理登录
    path: "/Login",
    name: "Login",
    component: () => import("@/views/bgManage/login/index"),
    meta: { title: "登录", hideTopbar: true },
  },
  {
    // 后台管理登录
    path: "/Register",
    name: "Register",
    component: () => import("@/views/bgManage/register/index"),
    meta: { title: "注册", hideTopbar: true },
  },
  {
    // 后台管理登录
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("@/views/bgManage/forgotPassword/index"),
    meta: { title: "忘记密码", hideTopbar: true },
  },
  {
    // 后台管理布局
    path: "/bgManage",
    component: () => import("@/views/bgManage/layouts/CommonLayout"),
    redirect: "/bgManage/projectIntroduction",
    meta: { hideTopbar: true },
    children: [

      {
        path: "projectIntroduction",
        name: "ProjectIntroduction",
        component: () => import("@/views/bgManage/firstView/projectIntroduction/index"),
        meta: { title: "双推双促工程介绍",hideTopbar: true}
      },
      {
        path: "achievementRegistration",
        name: "AchievementRegistration",
        component: () => import("@/views/bgManage/firstView/achievementRegistration/index"),
        meta: { title: "申报成果信息登记",hideTopbar: true}
      },
      {
        path: "achievementPreview",
        name: "AchievementPreview",
        component: () => import("@/views/bgManage/firstView/achievementPreview/index"),
        meta: { title: "申报成果信息预览",hideTopbar: true}
      },
      {
        path: "pendingPersonal",
        name: "PendingPersonal",
        component: () => import("@/views/bgManage/recommending/pendingPersonal/index"),
        meta: { title: "待个人推荐成果",hideTopbar: true}
      },
      {
        path: "recommendedPreview",
        name: "RecommendedPreview",
        component: () => import("@/views/bgManage/recommending/recommendedPreview/index"),
        meta: { title: "已推荐成果预览",hideTopbar: true}
      },
      {
        path: "unrecommendedPreview",
        name: "UnrecommendedPreview",
        component: () => import("@/views/bgManage/recommending/unrecommendedPreview/index"),
        meta: { title: "未推荐成果预览",hideTopbar: true}
      },
      {
        path: "recommendAll",
        name: "RecommendAll",
        component: () => import("@/views/bgManage/recommending/recommendAll/index"),
        meta: { title: "推荐个人全部成果",hideTopbar: true}
      },
      {
        path: "recommendUsers",
        name: "RecommendUsers",
        component: () => import("@/views/bgManage/recommending/recommendUsers/index"),
        meta: { title: "推荐个人已注册用户",hideTopbar: true}
      },
      {
        path: "secondDeclaration",
        name: "secondDeclaration",
        component: () => import("@/views/bgManage/judgesAndExperts/secondDeclaration/index"),
        meta: { title: "第二届新动能成果申报(2026年)",hideTopbar: true}
      },
      {
        path: "firstConferenceAchievements",
        name: "FirstConferenceAchievements",
        component: () => import("@/views/bgManage/judgesAndExperts/firstConferenceAchievements/index"),
        meta: { title: "第一届发布会成果(100)",hideTopbar: true}
      },
      {
        path: "nominatedAchievement",
        name: "NominatedAchievement",
        component: () => import("@/views/bgManage/judgesAndExperts/nominatedAchievement/index"),
        meta: { title: "第一届提名成果(150)",hideTopbar: true}
      },
      {
        path: "firstShortlistedAchievements",
        name: "FirstShortlistedAchievements",
        component: () => import("@/views/bgManage/judgesAndExperts/firstShortlistedAchievements/index"),
        meta: { title: "第一届入围成果(全部)",hideTopbar: true}
      },
      {
        path: "nonAchievementCooperationList",
        name: "NonAchievementCooperationList",
        component: () => import("@/views/bgManage/judgesAndExperts/nonAchievementCooperationList/index"),
        meta: { title: "非成果方成果合作服务申请列表",hideTopbar: true}
      },
      {
        path: "achievementExtensionServiceList",
        name: "AchievementExtensionServiceList",
        component: () => import("@/views/bgManage/judgesAndExperts/achievementExtensionServiceList/index"),
        meta: { title: "成果方成果延伸服务申请列表",hideTopbar: true}
      },
      {
        path: "judge/scoringTable",
        name: "judgeScoringTable",
        component: () => import("@/views/bgManage/expertJudges/scoringTable/index"),
        meta: { title: "打分表",hideTopbar: true}
      },
      {
        path: "judge/arrangeList",
        name: "judgeArrangeList",
        component: () => import("@/views/bgManage/expertJudges/arrangeList/index"),
        meta: { title: "安排表",hideTopbar: true}
      },
      {
        path: "judge/reviewList",
        name: "judgeReviewList",
        component: () => import("@/views/bgManage/expertJudges/reviewList/index"),
        meta: { title: "评审表",hideTopbar: true}
      },
      {
        path: "judge/expertReviewList",
        name: "judgeExpertReviewList",
        component: () => import("@/views/bgManage/expertJudges/expertReviewList/index"),
        meta: { title: "专家评审表",hideTopbar: true}
      }
    ]
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    // 跳转路由时页面滚到顶部
    return { x: 0, y: 0 };
  },
});

// 路由跳转前钩子函数中 - 执行进度条开始加载
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.query.title) {
    document.title = to.query.title;
  }
  NProgress.start();
  next();
});

// 路由跳转后钩子函数中 - 执行进度条加载结束
router.afterEach(() => {
  NProgress.done();
});

export default router;
